import { Fragment } from "react"

import { useTranslation } from "@/hooks/useTranslation"
import { ApplicationTag } from "@/molecules/ApplicationTag"

import { WorkLoadStatuses } from "@/domain/application"
import styles from "./ApplicationStatusPopover.module.scss"

export const ApplicationStatusPopover = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      {WorkLoadStatuses.map((status) => (
        <Fragment key={status}>
          <ApplicationTag type={status} />
          <span>
            {t(`inventory.application.statuses.description.${status}`)}
          </span>
        </Fragment>
      ))}
    </div>
  )
}
